import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationSelectModalComponent } from './organization-select-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [OrganizationSelectModalComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
  ],
})
export class OrganizationSelectModalModule {}
